import { queryOptions } from "@tanstack/react-query";
import { Application } from "merchant-api/types";
import { spiceroad } from "..";

export const associateApp = () =>
   spiceroad.post<Application>(`/v1/application/associate`)
    .then(res => res.data);

export const associateAppOptions = () =>
  queryOptions<Application>({
    queryKey: ['app'],
    queryFn: associateApp,
  });
